import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/login",
		name: "Login",
		component: Login
	},
	{
		path: "/newsroom",
		name: "Newsroom",
		component: () => import(/* webpackChunkName: "newsroom" */ "../views/Newsroom.vue")
	},
	{
		path: "/blog",
		name: "Blog",
		component: () => import(/* webpackChunkName: "blog" */ "../views/Blog.vue")
	},
	{
		path: "/frontpage",
		name: "Frontpage",
		component: () => import(/* webpackChunkName: "frontpage" */ "../views/Frontpage.vue")
	},
	{
		path: "/products",
		name: "Products",
		component: () => import(/* webpackChunkName: "products" */ "../views/Products")
	},
	{
		path: "/categories",
		name: "Categories",
		component: () => import(/* webpackChunkName: "categories" */ "../views/Categories")
	},
	{
		path: "/gallery",
		name: "Gallery",
		component: () => import(/* webpackChunkName: "gallery" */ "../views/Gallery.vue")
	},
	{
		path: "/sentinel",
		name: "Sentinel",
		component: () => import(/* webpackChunkName: "sentinel" */ "../views/Sentinel.vue")
	}
];

const router = new VueRouter({
	mode: "history",
	routes,
	scrollBehavior() {
		return {x: 0, y: 0};
	}
});

export default router
